//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('transportAreaPp', {
//        templateUrl: 'views/components/views/transportAreaPp/transportAreaPp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'transportAreaPpService', function ($stateParams, stateService, utilityService, modalService, translateService, transportAreaPpService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let transportAreaPpKeyno = $stateParams.transportareapp_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//    		vm.model = {
//                edit: {},
//    			selectListTransportAreas: [],
//    			lockedSave: false
//    		};

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//    		// #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await transportAreaPpService.getPostPlace({ transportareapp_keyno: transportAreaPpKeyno }))[0];

//                return loadTransportAreas();
//            }
            
//            async function loadTransportAreas() {
//                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id) !== true) return;
    			
//                return vm.model.selectListTransportAreas = await transportAreaPpService.listTransportAreas({ stockplace_id: vm.model.edit.stockplace_id });
//    		}

//            // #endregion LOAD PROCEDURE CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                transportAreaPpService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//    	}]
//    });
//})();
